const STORAGE_KEY = 'the-line:prefs:v1';

export interface Prefs {
  version: 1;
  /** Show the reasoning after each answer instead of advancing straight away. */
  explain: boolean;
}

export const DEFAULT_PREFS: Prefs = { version: 1, explain: true };

export function loadPrefs(): Prefs {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw) as Partial<Prefs>;
    if (parsed.version !== 1) return { ...DEFAULT_PREFS };
    return { version: 1, explain: parsed.explain !== false };
  } catch {
    return { ...DEFAULT_PREFS };
  }
}

export function savePrefs(next: Prefs): Prefs {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  } catch {
    // The assessment stays usable when storage is unavailable.
  }
  return next;
}
